// Super Quiz临时考试
export default [
  // 首页
  {
    path: '/SuperQuiz',
    name: 'SuperQuiz',
    component: () =>
    import(/* webpackChunkName: "SuperQuiz" */ '@/components/super-quiz/index')
  },
  // 考试页面
  {
    path: '/SuperQuizPaper',
    name: 'SuperQuizPaper',
    component: () =>
    import(/* webpackChunkName: "SuperQuiz" */ '@/components/super-quiz/paper')
  },
  // 考试页面样题演示
  {
    path: '/SuperQuizPaperDemo',
    name: 'SuperQuizPaperDemo',
    component: () =>
    import(/* webpackChunkName: "SuperQuiz" */ '@/components/super-quiz/paper-demo')
  },
  // 结尾页面
  {
    path: '/SuperQuizEnd',
    name: 'SuperQuizEnd',
    component: () =>
    import(/* webpackChunkName: "SuperQuiz" */ '@/components/super-quiz/end')
  },
  // 首页
  {
    path: '/SuperQuizNew',
    name: 'SuperQuizNew',
    meta: {
      Allbtn_info: false
    },
    component: () =>
      import(/* webpackChunkName: "SuperQuiz" */ '@/components/super-quiz-new/index')
  },
  {
    path: '/SuperQuizEndNew',
    name: 'SuperQuizEndNew',
    component: () =>
      import(/* webpackChunkName: "SuperQuiz" */ '@/components/super-quiz-new/end')
  },
  {
    path: '/SuperQuizPaperNew',
    name: 'SuperQuizPaperNew',
    component: () =>
      import(/* webpackChunkName: "SuperQuiz" */ '@/components/super-quiz-new/paper')
  },
  {
    path: '/previewIndex',
    name: 'previewIndex',
    component: () =>
      import(/* webpackChunkName: "SuperQuiz" */ '@/components/super-quiz-new/previewIndex')
  },
  {
    path: '/previewPaper',
    name: 'previewPaper',
    component: () =>
      import(/* webpackChunkName: "SuperQuiz" */ '@/components/super-quiz-new/previewPaper')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/super-quiz.js